import request from '@/config/axios'

export interface AgentMerchantRelVO {
  id?: number
  agentId?: number
  agentName?: string
  agentNo?: string
  merchantId?: number
  softwareId?: string
  regionCode?: string
  regionName?: string
  bindMode?: number
  inviteCode?: string
  signTime?: string
  confirmed?: boolean
  createTime?: string
  monthBasis?: number
  monthProfit?: number
}

export interface AgentTenantSettingVO {
  autoAssign?: boolean
  collisionStrategy?: number
}

export interface AgentRelChangeVO {
  id?: number
  merchantId?: number
  softwareId?: string
  relId?: number
  fromAgentId?: number
  fromAgentName?: string
  changeType?: number
  targetAgentId?: number
  targetAgentName?: string
  reason?: string
  status?: number
  rejectReason?: string
  auditTime?: string
  createTime?: string
}

export const getMerchantRelPage = (params: any) =>
  request.get<{ list: AgentMerchantRelVO[]; total: number }>({ url: '/agent/merchant-rel/page', params })

export const bindMerchantRel = (data: {
  agentId: number
  merchantId: number
  softwareId: string
  regionCode?: string
  regionName?: string
}) => request.post({ url: '/agent/merchant-rel/bind', data })

export const unbindMerchantRel = (id: number) =>
  request.delete({ url: '/agent/merchant-rel/unbind', params: { id } })

export const getTenantSetting = () =>
  request.get<AgentTenantSettingVO>({ url: '/agent/merchant-rel/setting/get' })

export const updateTenantSetting = (data: AgentTenantSettingVO) =>
  request.put({ url: '/agent/merchant-rel/setting/update', data })

export const getRelChangePage = (params: any) =>
  request.get<{ list: AgentRelChangeVO[]; total: number }>({ url: '/agent/rel-change/page', params })

export const auditRelChange = (data: { id: number; approved: boolean; rejectReason?: string }) =>
  request.put({ url: '/agent/rel-change/audit', data })
